import React, {useRef} from "react";
import { connect } from "react-redux";
import LookIntroPopper from "./lookIntroPopper";
import {LOOK_INTRO_STEPS} from "../../core/constants";

const LookIntroFooterAnchor = (props) => {

  const {introStep, isMobile, currentStep} = props;
  const anchorRef = useRef(null);

  if (introStep === LOOK_INTRO_STEPS.welcome) {
    return null
  }

  return (
    <div className="look-step__anchor look-step__anchor--footer" ref={anchorRef}>
      <LookIntroPopper anchorRef={anchorRef}
                       currentStep={currentStep || LOOK_INTRO_STEPS.review}
                       placement={isMobile ? "left" : "right"}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {introStep} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    introStep,
    isMobile,
  };
};

export default connect(mapStateToProps)(LookIntroFooterAnchor)
